import { ElementType, ReactNode } from 'react';

import { MenuItem, MenuItemProps } from '@mui/material';
import cx from 'classnames';

import styles from './DefaultMenuItem.module.scss';

interface DefaultMenuItemProps extends MenuItemProps {
  onClick?: () => void;
  className?: string;
  component?: ElementType;
  children: ReactNode;
  to?: string; // For NavLink support
}

export const DefaultMenuItem = ({
  onClick,
  className,
  component = 'button',
  children,
  to,
  ...rest
}: DefaultMenuItemProps) => {
  return (
    <MenuItem
      className={cx(styles.DefaultMenuItem, className || '')}
      onClick={onClick}
      component={component}
      to={to}
      {...rest}
    >
      {children}
    </MenuItem>
  );
};
